export default __webpack_public_path__ + "assets/NoMine.3425.svg";